module.exports = MaterialUI.Hidden;